/* eslint-disable camelcase */
export default {
  title: "Referral link",
  copied_to_clipboard: 'Your referral link has been copied to clipboard',
};
